import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    DataTableColumnPropsConstantType,
    DataTableContentDynamicStyleType,
    DataTableColumnPropsType
} from "./type";
import type {
    Mutable
} from "../../../../types";

export const DATA_TABLE_SKELETON_ROW_COUNT = 5;

export const DATA_TABLE_SKELETON_WIDTHS: Array<`${number}%`> = [
    "72%",
    "56%",
    "64%",
    "48%"
];

export const getDataTableColumnProps = ({
    column,
    width
}: DataTableColumnPropsConstantType): DataTableColumnPropsType => {
    const fixedWidth = width ?? (typeof column.width === "number" ? column.width : undefined);

    return {
        isShrink: fixedWidth !== undefined || column.width === "shrink",
        style: fixedWidth === undefined ? undefined : {
            width: fixedWidth
        },
        isNumeric: !!column.isNumeric,
        align: column.align
    };
};

const stylesheet = StyleSheet.create({
    rowOpen: {
        borderBottomColor: "transparent"
    },
    lead: {
        alignItems: "center",
        flexDirection: "row",
        maxWidth: "100%",
        minWidth: 0
    },
    container: {
        alignSelf: "stretch",
        flexShrink: 1
    },
    leadContent: {
        flexShrink: 1,
        minWidth: 0
    }
});

export const useStyles = ({
    selectWidth,
    spaces
}: DataTableContentDynamicStyleType) => {
    const styles = {
        notice: {
            paddingHorizontal: spaces.spacingMd,
            paddingBottom: spaces.spacingMd
        } as Mutable<ViewStyle>,
        lead: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>,
        select: {
            width: selectWidth
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
